module.exports = __webpack_public_path__ + "img/1496708026.c0798806.jpg";